import { render } from 'react-dom'

import RoutesProvider from './routes'
import { AuthProvider } from './context'

import { ga, initializePageAnalytics } from './routes/helpers'

import './index.css'
import './styles/animate.css'
import './assets/fonts/flaticons/flaticon.css'
import './styles/bootstrap/customizations.css'

initializePageAnalytics(ga)

render(
  <AuthProvider>
    <RoutesProvider />
  </AuthProvider>,
  document.getElementById('root')
)
